import React from 'react';
import ImageGallery from 'react-image-gallery';
import { images } from '../../constants/about-me-gallery';
import VerifiedIcon from '@mui/icons-material/Verified';
import SchoolIcon from '@mui/icons-material/School';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

const highlights = [
	{ icon: <FitnessCenterIcon sx={{ fontSize: 18 }} />, text: 'Trening siłowy dla kobiet' },
	{ icon: <VerifiedIcon sx={{ fontSize: 18 }} />, text: 'Trenerka personalna od 2022' },
	{ icon: <SchoolIcon sx={{ fontSize: 18 }} />, text: 'Gimnastyka korekcyjna' },
	{ icon: <SelfImprovementIcon sx={{ fontSize: 18 }} />, text: 'Trening medyczny' },
];

const stats = [
	{ value: '4+', label: 'Lata doświadczenia' },
	{ value: '100+', label: 'Zadowolonych klientek' },
	{ value: '5.0', label: 'Ocena Google' },
];

export default function AboutMePage() {
	return (
		<div className="pt-20 lg:pt-24">
			<section className="relative min-h-[85vh] flex items-center overflow-hidden bg-gradient-to-br from-[#fdf5f4] via-white to-[#faf6f2]">
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-primary-100/50 rounded-full blur-3xl" />
					<div className="absolute bottom-0 left-0 w-72 h-72 bg-[#f3ebe1]/60 rounded-full blur-3xl" />
				</div>

				<div className="relative max-w-7xl mx-auto px-6 py-16 lg:py-24 w-full">
					<div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
						<div className="lg:w-5/12 flex justify-center">
							<div className="relative w-full max-w-xs lg:max-w-sm">
								<div className="absolute -inset-5 bg-gradient-to-br from-primary-200 to-[#e6d4c0] rounded-[2.5rem] opacity-50 transform -rotate-3" />
								<div className="absolute -inset-2 bg-white rounded-[2rem] shadow-soft" />
								<img
									className="relative rounded-[1.75rem] shadow-soft-lg w-full object-cover aspect-[3/4]"
									alt="Amelia Pałczyńska"
									src="/photo_6239.jpg"
								/>
								<div className="absolute -bottom-5 -right-5 bg-white rounded-2xl shadow-soft-lg p-4">
									<div className="flex gap-5">
										{stats.map((s, i) => (
											<div key={i} className="text-center">
												<div className="font-bold text-lg text-primary-600 leading-none">{s.value}</div>
												<div className="text-xs text-gray-500 font-montserrat-custom-medium mt-0.5 whitespace-nowrap">{s.label}</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>

						<div className="lg:w-7/12 text-center lg:text-left">
							<span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-5 tracking-widest uppercase font-montserrat-custom-medium">
								O MNIE
							</span>
							<h1 className="font-bold-custom text-5xl lg:text-6xl text-gray-900 mb-6 leading-tight">
								Parę słów
								<span className="text-gradient"> o mnie</span>
							</h1>

							<div className="flex flex-wrap gap-2.5 justify-center lg:justify-start mb-8">
								{highlights.map((item, index) => (
									<div
										key={index}
										className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-soft text-sm font-medium text-gray-700 border border-gray-100"
									>
										<span className="text-primary-500">{item.icon}</span>
										{item.text}
									</div>
								))}
							</div>

							<p className="text-gray-600 mb-5 leading-relaxed font-montserrat-custom-medium text-lg">
								Nazywam się Amelia Pałczyńska i jestem trenerką personalną oraz instruktorką gimnastyki korekcyjnej. Studiuję Wychowanie Fizyczne na Uniwersytecie Rzeszowskim, a sport jest obecny w moim życiu od najmłodszych lat.
							</p>
							<p className="text-gray-600 mb-5 leading-relaxed font-montserrat-custom-medium">
								Od 2022 roku pracuję jako trenerka personalna, specjalizując się w treningu siłowym, poprawie sylwetki oraz budowaniu sprawności. Pomagam kobietom w każdym wieku — niezależnie od poziomu zaawansowania — osiągać ich cele w sposób bezpieczny i dopasowany do stylu życia.
							</p>
							<p className="text-gray-600 mb-5 leading-relaxed font-montserrat-custom-medium">
								W swojej pracy łączę trening personalny z elementami gimnastyki korekcyjnej oraz treningu medycznego. Dzięki temu pomagam nie tylko poprawić wygląd sylwetki, ale również zmniejszyć bóle kręgosłupa, poprawić postawę i zwiększyć komfort codziennego funkcjonowania.
							</p>
							<p className="text-gray-600 mb-8 leading-relaxed font-montserrat-custom-medium">
								Prowadzę treningi personalne oraz zajęcia w małych grupach w kameralnym <strong>Studio Sportu Dual</strong>. To miejsce stworzone dla kobiet, które szukają profesjonalnego wsparcia, indywidualnego podejścia i komfortowej atmosfery do pracy nad swoim ciałem.
							</p>

							<blockquote className="border-l-4 border-primary-400 pl-5 mb-8">
								<p className="text-gray-800 font-bold leading-relaxed font-montserrat-custom-medium italic">
									„Nieważne, na jakim etapie jesteś. Zaczynamy tam, gdzie jesteś — i idziemy po więcej."
								</p>
							</blockquote>

							<Link
								to="/contact"
								className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300"
							>
								UMÓW KONSULTACJĘ
								<ArrowForwardIcon fontSize="small" />
							</Link>
						</div>
					</div>
				</div>
			</section>

			<section className="py-16 lg:py-24 bg-white">
				<div className="max-w-7xl mx-auto px-6 w-full">
					<div className="flex flex-col lg:flex-row-reverse items-center gap-14 lg:gap-20">
						<div className="lg:w-5/12 flex justify-center">
							<div className="relative w-full max-w-xs lg:max-w-sm">
								<div className="absolute -inset-5 bg-gradient-to-br from-[#e6d4c0] to-primary-200 rounded-full opacity-50 transform rotate-3" />
								<img
									className="relative rounded-full shadow-soft-lg w-full object-cover aspect-square"
									alt="Amelia Pałczyńska"
									src="/photo_6262.jpg"
								/>
							</div>
						</div>
						<div className="lg:w-7/12 text-center lg:text-left">
							<h2 className="font-bold-custom text-4xl lg:text-5xl text-gray-900 mb-2">
								Kim jestem
								<span className="text-gradient"> i co mnie wyróżnia?</span>
							</h2>
							<p className="text-gray-600 mt-8 mb-6 leading-relaxed font-montserrat-custom-medium">
								Jestem Amelią Pałczyńską — trenerką personalną oraz instruktorką gimnastyki korekcyjnej. Dla której sport był obecny od zawsze: od tańca i tenisa ziemnego, aż po zawody sprinterskie. Zawsze wiedziałam, że chcę pomagać innym — i to stało się moją pasją oraz zawodem.
							</p>
							<p className="text-gray-600 mb-6 leading-relaxed font-montserrat-custom-medium">
								Regularnie poszerzam swoją wiedzę z zakresu treningu siłowego, treningu medycznego oraz dietetyki, aby zapewnić moim podopiecznym najwyższą jakość współpracy i trwałe efekty. Moim celem jest pomoc w przekraczaniu własnych barier — bo każda z nas jest w stanie więcej, niż myśli.
							</p>

							<div className="grid grid-cols-3 gap-4 mt-8">
								{stats.map((s, i) => (
									<div key={i} className="bg-gradient-to-br from-[#fdf5f4] to-white rounded-2xl p-5 text-center shadow-soft border border-gray-100">
										<div className="font-bold text-3xl text-primary-600 leading-none mb-1">{s.value}</div>
										<div className="text-xs text-gray-500 font-montserrat-custom-medium">{s.label}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="py-16 lg:py-24 bg-gradient-to-br from-[#faf6f2] to-white">
				<div className="max-w-5xl mx-auto px-6">
					<div className="text-center mb-12">
						<span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-4 tracking-widest uppercase font-montserrat-custom-medium">
							KWALIFIKACJE
						</span>
						<h2 className="font-bold-custom text-4xl lg:text-5xl text-gray-900">
							Moje <span className="text-gradient">certyfikaty</span>
						</h2>
					</div>

					<div className="bg-white rounded-3xl shadow-soft-lg p-6 lg:p-10">
						<ImageGallery
							items={images}
							showFullscreenButton={true}
							showPlayButton={false}
							showNav={true}
						/>
					</div>
				</div>
			</section>

			<section className="relative py-24 lg:py-32 overflow-hidden min-h-[380px] flex items-center">
				<div className="absolute inset-0">
					<img
						src="/photo_6278.jpg"
						alt=""
						className="w-full h-full object-cover object-center"
					/>
					<div className="absolute inset-0 bg-gradient-to-r from-gray-900/96 via-gray-900/80 to-gray-900/40" />
				</div>
				<div className="relative max-w-7xl mx-auto px-6">
					<div className="max-w-xl text-white">
						<h2 className="font-bold-custom text-4xl lg:text-5xl mb-5">
							Gotowa na współpracę?
						</h2>
						<p className="text-lg text-white/80 mb-10 font-montserrat-custom-light">
							Jeśli interesuje Cię współpraca ze mną, nie zwlekaj — zapisz się już dziś!
						</p>
						<Link
							to="/contact"
							className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300"
						>
							ZAPISZ SIĘ NA TRENING
							<ArrowForwardIcon fontSize="small" />
						</Link>
					</div>
				</div>
			</section>
		</div>
	);
}
